module.exports = {
  toLocation(newLocation) {
    window.location = newLocation;
  },

  toHref(newHref) {
    window.location.href = newHref;
  },

  getPathName() {
    return window.location.pathname;
  },
};
